module.exports = __webpack_public_path__ + "static/media/8.15d7399a.png";